<t4-header icon="glyphicon-stats"></t4-header>
<t4-container>
  <t4-data-table #tbl headline="" matSort reportName="LateRentals" [filterFields]="['RentalId', 'ObjectId', 'RegNo', 'Location', 'EndTime']" [autoGenerateColumns]="false">
    <ng-container matColumnDef="RentalId">
      <mat-header-cell *matHeaderCellDef mat-sort-header>RentalId</mat-header-cell>
      <mat-cell *matCellDef="let row"><t4-booking-link bookingId="{{row.RentalId}}"></t4-booking-link></mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="ObjectId">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Trailer</mat-header-cell>
      <mat-cell *matCellDef="let row"><t4-object-link [objectId]="row.ObjectId">{{ row.RegNo }}</t4-object-link></mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="Location">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Location</mat-header-cell>
      <mat-cell *matCellDef="let row"><t4-location-link [locationId]="row.LocationId">{{ row.Location }}</t4-location-link></mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="EndTime">
      <mat-header-cell *matHeaderCellDef mat-sort-header>End time</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.EndTime | date : 'd MMM y, HH:mm' }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="LatestCSAction">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Latest Action</mat-header-cell>
      <mat-cell *matCellDef="let row" style="display:flex; justify-content:space-between;"> <span>{{ row.LatestCSEvent}} </span><mat-icon *ngIf="row.LatestCSEvent != null" (click)="showCSHistory(row)">read_more</mat-icon> </mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
  </t4-data-table>
</t4-container>
